/**
 * @module middleware/SharedState
 * Middleware to apply common state to each action
 */
import { type Dispatch, type Store } from 'redux';
import { type Action as TypesafeAction } from 'typesafe-actions';

import { type WithSharedState } from 'src/types';

import { getCurrentListenerIdFromState } from '../lib/ListenerUtils';

/**
 * Applies bits of state to each action passing through
 * @param  {Object} store - redux
 * @param  {Object} next - dispatch function of next middleware in the chain
 * @param  {Object} action - the current action
 * @return {Object} The action to pass to the store
 */
export default ({ getState }: Store) =>
  <Action extends TypesafeAction>(next: Dispatch<Action>) =>
  (action: Action): WithSharedState<Action> => {
    const state = getState();
    const sharedStateAction: WithSharedState<Action> = {
      ...action,
      sharedState: {
        listenerId: getCurrentListenerIdFromState(state),
      },
    };
    return next(sharedStateAction);
  };
